import React from 'react';
import { css } from '@emotion/core';

import { positionRelative, marginAuto, spaceTopRelaxed, grid } from '@/styles';

import { SkeletonBlock } from './skeleton';
import PageHeader from './page-header';

const pageLayoutStyles = [positionRelative, marginAuto];

const EntityPageSkeleton: React.FC = () => (
  <div css={pageLayoutStyles}>
    <div
      css={[
        grid,
        css`
          grid-template-columns: 5fr 1fr;
        `,
      ]}
    >
      <SkeletonBlock />
      <SkeletonBlock />
    </div>
    <div css={spaceTopRelaxed}>
      <PageHeader title="" isLoading />
    </div>
  </div>
);

export default EntityPageSkeleton;
